export default {
    noPowerTip:
        '这不是你想要的，但我们是认真的。我只是想用一种特殊的方式告诉你，你无权访问此页面，或者该文件无效。您可以联系网站管理员以更快地解决问题，或返回网站首页浏览其他页面。',
}
